import { BrowserRouter } from "react-router";
import { RoutesProtected, RoutesPublic } from "./router/router.js";
import useAuth from "./services/useAuth";

const loadStyles = () => {
  try{
    const currentUrl = window.location.href;
    const onlyURL = currentUrl.split('/')[3];

    if (onlyURL !== "static") {
      import("../src/styles/_bases.scss")
        .catch((err) => console.error("Error cargando estilos base", err));
    } else {
      import("../src/styles/_fonts.scss")
        .catch((err) => console.error("Error cargando fuentes", err));

      import("../src/styles/components/_static.scss")
        .catch((err) => console.error("Error cargando estilos estáticos", err));
    }
  }catch(err){
      console.error("Error cargando estilos", err);
  }
};

loadStyles();

function App() {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      {user ? <RoutesProtected /> : <RoutesPublic />}
    </BrowserRouter>
  );
}

export default App;
